//@ts-nocheck
import { Card, CardBody, Col, UncontrolledAccordion } from "reactstrap";
import CommonCardHeader from "../../../../Common/CommonCardHeader";
import { WithIconsAccordions } from "../../../../Constant";
import { ACCORDION_ICON_DATA, ACCORDION_ICON_LIST } from "../../../../Data/UiKit/Accordion";
import { StaticAccordion } from "./StaticAccordion";
import CommonAccordionItem from "../Common/CommonAccordionItem";

const WithIconsAccordion = () => {
  return (
    <Col xl="6" sm="12">
      <Card>
        <CommonCardHeader title={WithIconsAccordions} span={ACCORDION_ICON_DATA} />
        <CardBody className="accordion-border">
          <UncontrolledAccordion stayOpen className="dark-accordion">
            <StaticAccordion />
            {ACCORDION_ICON_LIST.map((data, index) => (
              <CommonAccordionItem key={index} item={data} />
            ))}
          </UncontrolledAccordion>
        </CardBody>
      </Card>
    </Col>
  );
};

export default WithIconsAccordion;
